/*
 * This Class is used for personnel permissions on college side.
 *
 * Design:
 * We use an integer functioning as a binary int to represent permission levels,
 * and each of the permissions below is corresponding to one bit in that int.
 * e.g. decimal (129) = binary(1000011) = permission [0, 1, 7] = inst_prof,
 * booking_view and finance
 *
 * As a result the ORDER IS EXTREMELY VITAL, thus:
 * 1. if you want to remove one permission level, just leave it unused, don't remove
 * or comment any existing element in use.
 * 2. if you want to add new permissions levels, add them in the end of the lists.
 */

export const permIndices = {
    ed_col: 0,
    ed_cam: 1,
    ed_per: 2,
    ed_cla: 3,
    vi_book: 4,
    ed_book: 5,
    ed_pay: 6,
    vi_fin: 7,
    vi_lst: 8,
    ed_lst: 9,
}

const permissionList = [
    "Edit College Profile",
    "Manage Campuses",
    "Manage Personnel",
    "Manage Timetable",
    "View Bookings",
    "Manage Bookings",
    "Manage Payments",
    "View Finance",
    "View Listing",
    "Manage Job Listings",
]

const indices = Array(permissionList.length).fill().map((_, index) => index)

export const getPermissionList = () => {
    return permissionList
}

export const getPermissionSize = () => {
    return permissionList.length
}

export const getIndex = (key) => {
    if (permissionList.includes(key)) {
        return permissionList.indexOf(key)
    } else {
        throw new Error(`the key: ${key} is not recognized`)
    }
}

export const getPermissionName = (index) => {
    return permissionList[index]
}

export const getValue = (key) => {
    return 1 << getIndex(key)
}

export const firstHalfIndex = () => {
    return indices.filter(item => item < getPermissionSize() / 2)
}

export const secondHalfIndex = () => {
    return indices.filter(item => item >= getPermissionSize() / 2)
}